<template>
    <div class="card p-16">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'Card',
}
</script>

<style lang="scss" scoped>
.card {
    background-color: $card-background-color;
    border-radius: $spacing-unit-8;
    border: 1px solid lighten($card-background-color, 10%);
}
</style>
